// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-o_hg","advertDetailService__price":"c-o_hh"};